<template>
  <footer class="bg-neutral-900 text-white pt-12 pb-6">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center w-full justify-center gap-8 mb-8">
        <div>
          <div class="flex items-center justify-center space-x-2 mb-6">
            <i class="fa fa-bolt text-primary text-2xl"></i>
            <span class="text-lg font-semibold">AI工具集市</span>
          </div>
          <p class="text-neutral-400 text-sm mb-6">汇聚最优质的AI生成工具，连接创作者与使用者的桥梁。</p>
          <div class="flex space-x-4">
            <!-- <a href="#" class="w-8 h-8 rounded-full bg-neutral-800 flex items-center justify-center hover:bg-primary apple-transition">
              <i class="fa fa-twitter"></i>
            </a>
            <a href="#" class="w-8 h-8 rounded-full bg-neutral-800 flex items-center justify-center hover:bg-primary apple-transition">
              <i class="fa fa-github"></i>
            </a>
            <a href="#" class="w-8 h-8 rounded-full bg-neutral-800 flex items-center justify-center hover:bg-primary apple-transition">
              <i class="fa fa-linkedin"></i>
            </a> -->
          </div>
        </div>
        
        <!-- <div>
          <h4 class="font-medium mb-4">平台</h4>
          <ul class="space-y-2 text-sm text-neutral-400">
            <li><a href="#" class="hover:text-white apple-transition">关于我们</a></li>
            <li><a href="#" class="hover:text-white apple-transition">如何工作</a></li>
            <li><a href="#" class="hover:text-white apple-transition">常见问题</a></li>
            <li><a href="#" class="hover:text-white apple-transition">联系我们</a></li>
          </ul>
        </div>
        
        <div>
          <h4 class="font-medium mb-4">资源</h4>
          <ul class="space-y-2 text-sm text-neutral-400">
            <li><a href="#" class="hover:text-white apple-transition">开发者文档</a></li>
            <li><a href="#" class="hover:text-white apple-transition">API参考</a></li>
            <li><a href="#" class="hover:text-white apple-transition">教程</a></li>
            <li><a href="#" class="hover:text-white apple-transition">帮助中心</a></li>
          </ul>
        </div>
        
        <div>
          <h4 class="font-medium mb-4">法律</h4>
          <ul class="space-y-2 text-sm text-neutral-400">
            <li><a href="#" class="hover:text-white apple-transition">服务条款</a></li>
            <li><a href="#" class="hover:text-white apple-transition">隐私政策</a></li>
            <li><a href="#" class="hover:text-white apple-transition">版权声明</a></li>
          </ul>
        </div> -->
      </div>
      
      <div class="border-t border-neutral-800 pt-6 text-center text-neutral-500 text-xs">
        <p>&copy; 2026 义乌市教育研修院 智慧教育中心. 保留所有权利。</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>
